var bundleQuantity = 1;
var bundleVariant;
const bundleItems = [
  {
    "qty": 1,
    "varid": "31196183429162"
  },
  {
    "qty": 2,
    "varid": "39577540395050"
  },
  {
    "qty": 3,
    "varid": "39577542721578"
  }
]
const findVaridByQty = (items, qty) => {
  const item = items.find(item => item.qty === qty);
  return item ? item.varid : null;
};
if($('body').hasClass('product')){
$('form.product_form[data-productid="4349600956458"]').each(function () {

    const formThis = $(this);
    // document has stickyBtn only on PDP
    const inputQuantity = formThis.find('.form-product-quantity');
    const labels = formThis.find('.rc_block label');
    const labelRadios = formThis.find('input[name="purchase_type"]');
    const onetimeProductPrice = 498;
    const onetimeProductLabel = formThis.parents('#product_description').find('.badges.badge-one').find('.badge.sale');
    const bundleWrapper = formThis.find('.bundle-discounts');
    const bundleOptions = formThis.find('.bundles-variants__item');
    let subscriptionProductPrice = onetimeProductPrice;
    subscriptionProductPrice = subscriptionProductPrice - subscriptionProductPrice * 0.2;
  
    formThis.find('.product-add').show();
    formThis.find('button[data-tiered-discount]').hide();

    function checkDiscount(quantity = 1, reverseString = false) {
        const discount10per = 0.10;
        const discount15per = 0.15;
        let priceWithDiscount = null;
        let priceOriginal = null;
        let saveAmount = null;
  
        switch (quantity) {
            case 2: {
                priceOriginal = onetimeProductPrice * quantity;
                priceWithDiscount = priceOriginal - (priceOriginal * discount10per)
                saveAmount = (Math.round( (priceOriginal - priceWithDiscount) * 100 )/100 ).toString()
                $('.badge-one').addClass('discount');
                var priceLabel = `<span class="sub-price"><span class="sp-price"><s>${priceOriginal}kr</s></span></span><span class="p-price">${priceWithDiscount}kr</span>`;
                $('#product-price .custom-price').html(priceLabel);
                return `<strong><span class="woocommerce-Price-amount amount">${saveAmount}</span> <span class="woocommerce-Price-currencySymbol">kr</span></strong>  rabatt`
                /*if (!reverseString) {
                    return `${priceWithDiscount} kr <s style="opacity: 0.5">${priceOriginal} kr</s>`
                } else {
                    return ` <s style="opacity: 0.5">${priceOriginal} kr</s> ${priceWithDiscount} kr`
                }*/
            }
            case 3: {
                priceOriginal = onetimeProductPrice * quantity;
                priceWithDiscount = priceOriginal - (priceOriginal * discount15per)
                saveAmount = (Math.round( (priceOriginal - priceWithDiscount) * 100 )/100 ).toString()
                $('.badge-one').addClass('discount');
                var priceLabel = `<span class="sub-price"><span class="sp-price"><s>${priceOriginal}kr</s></span></span><span class="p-price">${priceWithDiscount}kr</span>`;
                $('#product-price .custom-price').html(priceLabel);
                return `<strong><span class="woocommerce-Price-amount amount">${saveAmount}</span> <span class="woocommerce-Price-currencySymbol">kr</span></strong>  rabatt`
                /*if (!reverseString) {
                    return `${priceWithDiscount} kr <s style="opacity: 0.5">${priceOriginal} kr</s>`
                } else {
                    return `<s style="opacity: 0.5">${priceOriginal} kr</s> ${priceWithDiscount} kr`
                }*/
            }
            default: {
                $('.badge-one').removeClass('discount');
                $('#product-price .custom-price').html(onetimeProductPrice + 'kr');
                return ``;
                /*return `${onetimeProductPrice} kr`;*/
            }
        }
    }
    
    labelRadios.on('click', function() {
      $(this).next('label').trigger('click');
    });

    labels.on('click', function () {
      console.log("TEST:: click labels");
        const _form = $(this).closest('form');
        if ($(this).hasClass('rc_label__onetime')) {
            bundleWrapper.addClass('active');
            $('.badge-one .sale').hide();
            _form.find('.product-add').hide();
            _form.find('button[data-tiered-discount]').show();
        }
        else if ($(this).hasClass('rc_label__autodeliver')) {
            bundleWrapper.removeClass('active');

            bundleOptions.first().click();
            onetimeProductLabel.html(checkDiscount(1, true));
            
            _form.find('.product-add').show();
            _form.find('button[data-tiered-discount]').hide();
        }
    });
  
    bundleOptions.on('click', function (e) { 
        const quantity = $(this).data('quantity');

        let varidByQty = findVaridByQty(bundleItems, quantity);
        $('#recharge-override-varid').val(`${varidByQty}`);
        $('#recharge-override-spid').val('');
        const isBundleWrapperVisible = bundleWrapper.is(":visible")
  
        bundleOptions.removeClass('active');
        $(this).addClass('active');
        inputQuantity.val(quantity);
  
        if(isBundleWrapperVisible) { 
            //if (stickyBtn) stickyBtn.innerHTML = checkDiscount(Number(quantity));
            onetimeProductLabel.html(checkDiscount(Number(quantity), true));
            if (quantity == 1) {
              $('.badge-one .sale').hide();
            } else {
              $('.badge-one .sale').show();
            }
        }
        else {
            inputQuantity.val(quantity);
           // if (stickyBtn) stickyBtn.innerHTML = `$${subscriptionProductPrice.toFixed(2)}`.replace('.00', '');
        }
    });
  });
  
  $(document).ready(function() {
    $(document).on('click', 'button[data-tiered-discount]', function(e) { 
      e.preventDefault();
      var quantity = $(this).closest('form').find('input[name="quantity"]').val();
      var product_id, discount_text = null;
      if (quantity == 2) {
        product_id = '39577540395050';
        discount_text = 'Bundle & Save 10%';
      } else if (quantity == 3) {
        product_id = '39577542721578';
        discount_text = 'Bundle & Save 15%';
      } else {
        product_id = '31196183429162';
        discount_text = '';
        //$(this).closest('form').find('input#addToCart').trigger('click');
      }
      if (product_id != null) {
        $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          dataType:'json',
          success:function() {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
                quantity: 1,
                id: product_id,
                properties: {
                  'Discount': discount_text
                }
              },
              dataType: 'json', 
              success: function() {
                window.location.href = '/checkout';
              }
            });
          }
        });
      }
    });
  });
  
}